

import React, { memo } from 'react';
import cx from 'classnames';
import { Image, Button, Text } from '../../ui-kit';
import './styles/_explore-more.scss';










function ExploreMore({
  title,
  subtitle,
  btnText,
  imageUrl,
  onClick,
  className
}) {
  return (
    <div className={cx('explore-more', className)}>
      <Image
        width="100%"
        height="100%"
        backgroundSize="cover"
        defaultImageIcon="faq"
        imageUrl={imageUrl} />

      <div className="explore-more__content">
        <Text darkTheme heading4>
          {subtitle}
        </Text>
        <Text heading2 darkTheme>{title}</Text>
        <Button onClick={onClick}>
          {btnText}
        </Button>
      </div>
    </div>);

}

ExploreMore.defaultProps = {
  subtitle: 'Need help?',
  btnText: 'Explore More'
};

export default memo(ExploreMore);